import "./Login.scss";
import { API_URL } from "../../utils/axios";
import axios from "axios";
import { useState } from "react";

const Login = (props) => {
  console.log(props);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const handleUsernameChange = (e) => {
    setUsername(e.target.value);
  };
  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const user = {
      username,
      password,
    };

    axios
      .post(API_URL + "/login", {
        ...user,
      })
      .then((response) => {
        localStorage.setItem("token", response.data.token);
        return response;
      })
      .then((response) => (window.location = "/admin"))
      .catch((error) => console.log(error));
  };
  return (
    <form className="login" onSubmit={handleSubmit}>
      <label htmlFor="username" className="login__label">
        USERNAME{" "}
      </label>
      <input
        className="login__input"
        type="text"
        id="username"
        name="username"
        placeholder="Username"
        onChange={handleUsernameChange}
        value={username}
      />
      <label htmlFor="password" className="login__label">
        PASSWORD
      </label>
      <input
        className="login__input"
        type="password"
        id="password"
        name="password"
        placeholder="Password"
        onChange={handlePasswordChange}
        value={password}
      />
      <button className="login__button">SUBMIT</button>
    </form>
  );
};

export default Login;
